import {
  UIActionTypes,
  UIState,
  DesignTab,
  Checkboxes,
  OpenDesignModalAction,
  CloseDesignModalAction,
  SetDesignTabAction,
  OpenSettingsModalAction,
  CloseSettingsModalAction,
  CloseMissionsModalAction,
  ToggleSettingAction,
  UpdateSettingsAction,
  CloseAllPanelsAction,
  OpenMissionCompletePopupAction,
  CloseMissionCompletePopupAction,
  ToggleIsNewMissionAction,
} from '../../types/gameUI';

export const updateUIState = (payload: Partial<UIState>) => ({
  type: UIActionTypes.UPDATE_UI_STATE,
  payload
} as const);

export const openDesignModal = (tab?: DesignTab): OpenDesignModalAction => ({
  type: UIActionTypes.OPEN_DESIGN_MODAL,
  payload: tab
});

export const closeDesignModal = (): CloseDesignModalAction => ({
  type: UIActionTypes.CLOSE_DESIGN_MODAL
});

export const setDesignTab = (tab: DesignTab): SetDesignTabAction => ({
  type: UIActionTypes.SET_DESIGN_TAB,
  payload: tab
});

export const openSettingsModal = (): OpenSettingsModalAction => ({
  type: UIActionTypes.OPEN_SETTINGS_MODAL
});

export const closeSettingsModal = (): CloseSettingsModalAction => ({
  type: UIActionTypes.CLOSE_SETTINGS_MODAL
});

export const closeMissionsModal = (): CloseMissionsModalAction => ({
  type: UIActionTypes.CLOSE_MISSIONS_MODAL
});

export const closeAllPanels = (): CloseAllPanelsAction => ({
  type: UIActionTypes.CLOSE_ALL_PANELS
});

export const toggleIsNewMission = (value: boolean): ToggleIsNewMissionAction => ({
  type: UIActionTypes.TOGGLE_IS_NEW_MISSION,
  payload: value
});

// Settings Actions
export const toggleSetting = (key: string): ToggleSettingAction => ({
  type: UIActionTypes.TOGGLE_SETTING,
  payload: key
});

export const updateSettings = (settings: Checkboxes[]): UpdateSettingsAction => ({
  type: UIActionTypes.UPDATE_SETTINGS,
  payload: settings
});

export const openMissionCompletePopup = (placement: 'winscreen' | 'sidebar'): OpenMissionCompletePopupAction => ({
  type: UIActionTypes.OPEN_MISSION_COMPLETE_POPUP,
  payload: placement
});

export const closeMissionCompletePopup = (): CloseMissionCompletePopupAction => ({
  type: UIActionTypes.CLOSE_MISSION_COMPLETE_POPUP
});

 